/* =========================================================
   VFW Hero Carousel — deck rail (P5, respec 2026-07-24)
   Every slide is a full-bleed crossfade layer; one universal
   rail of labelled chips (Home + each platform + Coming Soon,
   FIXED order) switches the active slide. No morph, no deck
   rotation — stable positions so a returning buyer finds
   "Chevelle" in the same spot every time (frictionless for the
   45–75 ICP). Click/keyboard driven, never autoplay.

   Chips are real <a> links (graceful no-JS → platform LP); this
   element intercepts the click to swap the slide instead.
   Reduced motion: the crossfade transition is killed globally;
   switching still works, instantly.
   ========================================================= */

(() => {
  if (customElements.get('vfw-hero-carousel')) return;

  class VfwHeroCarousel extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-hc-item]'));
      this.panes = Array.from(this.querySelectorAll('[data-hc-pane]'));
      this.chips = Array.from(this.querySelectorAll('[data-hc-chip]'));
      if (this.items.length < 2) return;

      this.active = Math.max(0, this.items.findIndex((el) => el.classList.contains('is-active')));

      this.addEventListener('click', (e) => {
        const chip = e.target.closest('[data-hc-go]');
        if (!chip || !this.contains(chip)) return;
        e.preventDefault();
        this.activate(Number(chip.dataset.hcGo), chip);
      });

      this.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        if (!e.target.closest('[data-hc-go]')) return;
        e.preventDefault();
        const step = e.key === 'ArrowRight' ? 1 : -1;
        const next = (this.active + step + this.items.length) % this.items.length;
        const chip = this.chips.find((c) => Number(c.dataset.hcGo) === next);
        this.activate(next, chip);
        if (chip) chip.focus();
      });

      this.render();
      this.classList.add('vfw-hc--ready');
    }

    render() {
      this.items.forEach((el, i) => el.classList.toggle('is-active', i === this.active));
      this.panes.forEach((pane, i) => {
        const on = i === this.active;
        pane.classList.toggle('is-active', on);
        if (on) pane.removeAttribute('hidden');
        else pane.setAttribute('hidden', '');
      });
      this.chips.forEach((chip) => {
        const on = Number(chip.dataset.hcGo) === this.active;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    activate(next, chip) {
      if (next === this.active || !this.items[next]) return;
      this.active = next;
      this.render();
      // keep the chosen chip visible in the scrolling rail
      if (chip && chip.scrollIntoView) {
        chip.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }
  }

  customElements.define('vfw-hero-carousel', VfwHeroCarousel);
})();
